import Vue from "vue";
import VueRouter from "vue-router";
import JwtService from "@/common/jwt.service.js";
import { PURGE_AUTH } from "@/store/mutations.type";
import goTo from "vuetify/lib/services/goto";
import { SCREEN } from "@/common/auth.const";
import { checkRole } from "@/router/role";
import { GET_ROLE } from "@/api/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: SCREEN.LOGIN.PATH,
    name: SCREEN.LOGIN.NAME,
    component: () => import("../views/Login"),
    meta: {
      guest: true,
    },
    children: [],
  },
  {
    path: "/",
    component: () =>
      import(
        /* webpackChunkName: "layout_default" */ "../layout/Default"
      ).catch((e) => refresh()),
    meta: {
      requiredAuth: true,
    },
    children: [
      {
        path: SCREEN.HOME.PATH,
        name: SCREEN.HOME.NAME,
        component: () => import(/* webpackChunkName: "home" */ "../views/Home"),
      },
      {
        path: SCREEN.CLASSIFICATION_REPORT.PATH,
        name: SCREEN.CLASSIFICATION_REPORT.NAME,
        component: () =>
          import(
            /* webpackChunkName: "home" */ "../views/report/ClassificationReport"
          ),
      },
      {
        path: SCREEN.AGGREGATION_CORRECTION_REPORT.PATH,
        name: SCREEN.AGGREGATION_CORRECTION_REPORT.NAME,
        component: () =>
          import(
            /* webpackChunkName: "home" */ "../views/report/AggregationCorrectionReport"
          ),
      },
      {
        name: SCREEN.ERR403.NAME,
        path: SCREEN.ERR403.PATH,
        component: () =>
          import(
            /* webpackChunkName: "error403" */ "../views/error/Error403.vue"
          ),
      },
    ],
  },
  {
    name: SCREEN.ERR404.NAME,
    path: SCREEN.ERR404.PATH,
    component: () =>
      import(/* webpackChunkName: "error_404" */ "../views/error/Error404"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo);
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiredAuth)) {
    if (!JwtService.isLogged()) {
      let urlLogin = "/login";
      vx.commit(PURGE_AUTH);
      next({
        path: urlLogin ? urlLogin : "/login",
        params: { nextUrl: to.fullPath },
        query: { redirect: to.fullPath },
      });
      return;
    }

    const ROLE_NAME = (await GET_ROLE()).data;
    if (!checkRole(to.name, ROLE_NAME) && "Error403" !== to.name) {
      next({ path: "/403" });
      return;
    }
    next();
    return;
  }

  if (to.matched.some((record) => record.meta.guest)) {
    if (!JwtService.isLogged()) {
      vx.commit(PURGE_AUTH);
      next();
      return;
    }
    if (to.name === "Login") {
      next("/");
      return;
    }
  }

  next();
});

export default router;

function refresh() {
  window.location.reload();
}
